export const getAssignmentRoleType = (assignment) =>
  assignment?.role?.roleType ?? assignment?.role?.role_type ?? null;

export const getAssignmentRoleName = (assignment) =>
  assignment?.role?.roleName ?? assignment?.role?.role_name ?? null;

export const isAssignmentActive = (assignment) =>
  assignment?.isActive !== false && assignment?.role?.is_active !== false;

export const getUserActiveRoleTypes = (user) => {
  if (!user?.roleAssignments?.length) {
    return user?.role ? [user.role] : [];
  }
  return user.roleAssignments
    .filter(isAssignmentActive)
    .map(getAssignmentRoleType)
    .filter(Boolean);
};

export const getPrimaryRoleType = (user) => {
  const activeTypes = getUserActiveRoleTypes(user);
  if (activeTypes.length > 0) return activeTypes[0];
  return user?.role || 'staff';
};

export const userMatchesRoleFilter = (user, roleFilter) => {
  if (!roleFilter || roleFilter === 'all') return true;
  const activeTypes = getUserActiveRoleTypes(user);
  if (activeTypes.length > 0) {
    return activeTypes.includes(roleFilter);
  }
  return user?.role === roleFilter;
};

export const userMatchesSearch = (user, searchLower) => {
  if (!searchLower) return true;

  if (user?.name?.toLowerCase()?.includes(searchLower)) return true;
  if (user?.email?.toLowerCase()?.includes(searchLower)) return true;

  const roleTypes = getUserActiveRoleTypes(user);
  if (roleTypes.some((t) => t?.toLowerCase()?.includes(searchLower))) return true;

  if (user?.roleAssignments?.length) {
    const matchesAssignment = user.roleAssignments.some((assignment) => {
      const roleType = getAssignmentRoleType(assignment);
      const roleName = getAssignmentRoleName(assignment);
      return (
        roleType?.toLowerCase()?.includes(searchLower) ||
        roleName?.toLowerCase()?.includes(searchLower)
      );
    });
    if (matchesAssignment) return true;
  }

  return user?.role?.toLowerCase()?.includes(searchLower) ?? false;
};
